<template>
  <div class="com-captch-input">
    <gkFormText 
      :color="color" 
      :size="size"
      :field="field"
      :rule="mergeRule"
      :customRule="{checkCaptcha: customRule.checkCaptcha}"
      :validity="validity"
      :disabled="disabled" 
      placeholder="请输入验证码"
      @input="$emit('input', $event)" 
    >
      <template slot="error" slot-scope="{message}">
        <slot name="error" :message="message">{{message}}</slot>
      </template>
    </gkFormText>
    <div class="captch-wrap">
      <img :src="captchUrl" alt="点击刷新" />
    </div>
    <div :class="['refresh', color]" @click="refresh">换一换</div>
  </div>
</template>
<script>
import VueTypes from 'vue-types'
import gkFormText from 'gkui/form/FormText'
import config from '../../config/index'
export default {
  name: 'com-captch-input',
  components: {
    gkFormText
  },
  props: {
    host: VueTypes.string.def(config.baseHost),
    url: VueTypes.string.isRequired,
    color: VueTypes.string.def('green'),
    size: VueTypes.string.def('normal'),
    field: VueTypes.string.isRequired,
    rule: VueTypes.oneOfType([String, Array]).def(''),
    validity: VueTypes.bool.def(false),
    disabled: VueTypes.bool.def(false),
    handleCheck: VueTypes.func
  },
  data () {
    return {
      guid: Date.now()
    }
  },
  computed: {
    captchUrl () {
      return this.host + this.url + '?' + this.guid
    },
    mergeRule () {
      this.rule.push({
        'checkCaptcha': '验证码错误'
      })
      return this.rule
    },
    customRule () {
      return {
        checkCaptcha: (value) => {
          return this.handleCheck(value) || {
            valid: true
          }
        }
      }
    }
  },
  created () {
  },
  methods: {
    /**
     * 刷新验证码
     */
    refresh () {
      this.guid = Date.now()
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/css/_common";
.com-captch-input {
  display: flex;
  // align-items: center;

  & .gkui-form-element-text {
    flex: 1;
    // width: 122px;

    &[disabled] {
      background: transparent!important;
      border-bottom: 1px solid #D9D9D9!important;
      color: $bodyBlack!important;
      user-select: none;
      cursor: not-allowed;
    }
  }

  & .captch-wrap {
    flex: 1;
    // flex: 94px 0 0; 
    height: 45px;
    margin-left: 20px;
    // transform: translateY(-4px);

    & img {
      width: 100%; height: 100%;
    }
  }

  & .refresh {
    display: flex;
    align-items: center;
    position: relative;
    height: 45px;
    @include lineFont(14, 400);
    color: $lightGreen;
    cursor: pointer;

    &.underline {
      color: $blue;
    }
  }
}
</style>
